import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '../../../core/services/user.service';
import { User } from '../../../core/models/user.model';

@Pipe({
    name: 'userDataByKey',
    standalone: false
})
export class UserDataByKeyPipe implements PipeTransform {
    constructor(private readonly userService: UserService) {
    }

    transform(key: keyof User): Observable<any> {
        return this.userService.listenToUserChangesByKey(key);
    }
}
